import { Component } from '@angular/core';

@Component({
  selector: 'app-refundpolicy',
  templateUrl: './refundpolicy.component.html',
  styleUrl: './refundpolicy.component.scss'
})
export class RefundpolicyComponent {
 contentReady: boolean = false;
}
